
  import { HOST, GAME, PROTOCOL_VERSION, gameMessageProblem } from '../packages/sdk/src/wire-hitz-v1.ts'
  import PARAMS from './platform/params.json'
  import { createState, placeBet, resolveAttempt, closeEvent, newDay, finiteBonusPct, levelOf, levelSummary, rankingPrizes } from './platform/economy.ts'

  // ---- Simulated platform (AGENTS.md: the client never computes money; all of this lives in the host page, dev only). ----
  const params = new URLSearchParams(location.search)
  const brl = (v) => 'R$ ' + v.toFixed(2).replace('.', ',')
  const pct = (v, d = 1) => (v * 100).toFixed(d).replace('.', ',') + '%'
  const num = (v, d = 1) => v == null ? '—' : Number(v).toFixed(d).replace('.', ',')
  const store = {
    get(k, d) { try { const v = localStorage.getItem('hitz-mock-' + k); return v === null ? d : JSON.parse(v) } catch { return d } },
    set(k, v) { try { localStorage.setItem('hitz-mock-' + k, JSON.stringify(v)) } catch { /* storage blocked */ } }
  }
  const EXAMPLES = [{ name: 'Exemplo A', points: 5200, score: 4600, example: true }, { name: 'Exemplo B', points: 4100, score: 4200, example: true }, { name: 'Exemplo C', points: 2900, score: 3700, example: true }]
  let state = store.get('platform', null) ?? createState(PARAMS)
  if (!state.ranking.some((r) => r.example)) state.ranking.push(...EXAMPLES)
  const save = () => store.set('platform', state)
  const $ = (id) => document.getElementById(id)
  const autobet = () => $('autobet').checked
  if (params.has('autobet')) $('autobet').checked = true
  const autoBetAmount = () => Number(params.get('autobet')) || PARAMS.wallet.bets[0]

  const render = () => {
    $('wallet').textContent = brl(state.wallet); $('piggy').textContent = brl(state.piggy); $('day').textContent = state.day
    $('potProg').textContent = brl(state.pots.progression); $('potHitz').textContent = brl(state.pots.hitz); $('potRank').textContent = brl(state.pots.ranking)
    const req = state.event.requested.reduce((a, b) => a + b.requested, 0)
    $('evReq').textContent = brl(req); $('evCount').textContent = state.event.requested.length; $('evIn').textContent = brl(state.event.inflow)
    $('evTot').textContent = state.totals.events; $('evLim').textContent = state.totals.limitedEvents
    $('bonusTot').textContent = `${brl(state.totals.bonusRequested)} × ${brl(state.totals.bonusPaid)}`
    const rows = Object.values(state.levels).sort((a, b) => Number(a.id) - Number(b.id)).map((l) => levelSummary(l, PARAMS))
    $('levels').innerHTML = '<tr><th>nível</th><th>p cadastrada</th><th>barra</th><th>U (24 h)</th><th>observada</th><th>partidas</th><th>mediana (vitórias)</th><th>bônus na mediana</th><th>equilíbrio</th></tr>' +
      (rows.length ? rows.map((r) => `<tr><td>${r.id}</td><td>${num(r.pIni)}%</td><td><b style="font-size:13px">${num(r.p)}%</b></td><td>${r.users24h}</td><td>${r.observedWinRate == null ? '—' : num(r.observedWinRate) + '%'}</td><td>${r.won}/${r.played}</td><td>${r.medianWinScore == null ? '—' : Math.round(r.medianWinScore)}</td><td>${pct(r.bonusAtMedian)}</td><td class="${r.pIni > r.equilibriumWinRate ? 'lim' : ''}">${num(r.equilibriumWinRate)}%</td></tr>`).join('') : '<tr><td colspan="9"><small>nenhum nível jogado ainda neste navegador</small></td></tr>')
    const sorted = [...state.ranking].sort((a, b) => b.points - a.points)
    const prizes = rankingPrizes(state.ranking, state.pots.ranking, PARAMS)
    $('rank').innerHTML = sorted.map((r) => { const p = prizes.find((x) => x.name === r.name); return `<tr class="${r.example ? '' : 'me'}"><td>${p?.position ?? '—'}º</td><td>${r.name}${r.example ? ' <small>(exemplo)</small>' : ''}</td><td>${Math.round(r.points)} pts</td><td>${r.example ? '<small>não paga</small>' : brl(p?.prize ?? 0)}</td></tr>` }).join('')
    save()
  }
  const ribbon = (text, cls) => { const r = $('ribbon'); r.textContent = text; r.className = 'ribbon show ' + cls; setTimeout(() => r.classList.remove('show'), 6000) }
  $('resetWallet').onclick = () => { state.wallet = PARAMS.wallet.start; render() }
  $('resetPlatform').onclick = () => { state = createState(PARAMS); state.ranking.push(...EXAMPLES); $('lastCard').className = 'card'; $('lastTitle').textContent = '—'; $('lastInfo').textContent = 'sem tentativas'; $('lastClose').textContent = ''; render() }
  $('closeEvent').onclick = () => {
    const c = closeEvent(state, PARAMS)
    $('lastClose').textContent = `evento ${c.count ? '' : 'vazio '}fechado: pedido ${brl(c.requested)} · disponível ${brl(c.available)} · solvência ${pct(c.solvency, 0)} · pago ${brl(c.paid)}${c.limited ? ' · LIMITADO (rateio)' : ''}`
    line(`platform: ${$('lastClose').textContent}`, 'money'); render()
  }
  $('newDay').onclick = () => {
    const d = newDay(state, PARAMS)
    const mine = d.prizes.find((p) => !p.example && p.prize > 0)
    $('lastClose').textContent = `novo dia ${state.day}${d.event ? `: evento fechado com solvência ${pct(d.event.solvency, 0)}` : ''}${mine ? ` · ranking pagou ${brl(mine.prize)} (${mine.position}º)` : ' · ranking sem prêmio para você'}`
    line(`platform: ${$('lastClose').textContent}`, 'money'); render()
  }
  render()

  const frame = document.getElementById('game')
  const log = document.getElementById('log')
  const stat = document.getElementById('stat')
  const rand = () => crypto.getRandomValues(new Uint32Array(1))[0]
  const S = { game: null, sessionId: null, nonce: null, attempt: null, lastAttemptId: null, lastStarted: null, outcome: false, pending: null }
  const counts = { messages: 0, invalid: 0, duplicates: 0, closeRequests: 0 }
  const seen = new Set()
  window.__messages = []   // accepted game → host messages
  window.__invalid = []    // rejected game → host messages, with the reason
  window.__attempts = {}   // attemptId → { authorization, actions, checkpoints, outcome } (replay log)
  window.__platform = () => state // the simulated economy, for tests and for reading in the console

  const line = (s, cls = '') => {
    const d = document.createElement('div'); d.textContent = s; if (cls) d.className = cls
    log.append(d); log.scrollTop = log.scrollHeight
  }
  const refresh = () => {
    stat.textContent = `messages ${counts.messages} · invalid ${counts.invalid} · duplicates ignored ${counts.duplicates}` +
      ` · attempt ${S.attempt ?? '—'} · close requests ${counts.closeRequests}`
  }
  const send = (messageType, payload, extra = {}) => {
    const m = {
      protocolVersion: PROTOCOL_VERSION, gameId: S.game.gameId, gameVersion: S.game.gameVersion,
      sessionId: S.sessionId, nonce: S.nonce, messageId: crypto.randomUUID(), messageType,
      occurredAt: new Date().toISOString(), payload, ...extra
    }
    frame.contentWindow.postMessage(m, location.origin)
    line(`host → ${messageType} ${m.attemptId ?? ''} ${JSON.stringify(payload)}`, 'host')
    return m
  }
  const finalize = () => {
    if (!S.attempt) return
    send(HOST.attemptFinalized, {}, { attemptId: S.attempt })
    S.lastAttemptId = S.attempt; S.attempt = null; S.outcome = false; refresh()
  }
  const reject = (m, reason) => { counts.invalid++; window.__invalid.push({ reason, message: m }); line(`INVALID (${reason}) ${JSON.stringify(m)}`, 'bad') }

  window.addEventListener('message', (ev) => {
    if (ev.source !== frame.contentWindow || ev.origin !== location.origin) return
    const m = ev.data
    if (!m || typeof m !== 'object') return
    const problem = gameMessageProblem(m)
    if (problem) return reject(m, problem)
    if (seen.has(m.messageId)) { counts.duplicates++; refresh(); return }
    seen.add(m.messageId)
    if (m.messageType === GAME.ready) {
      S.game = { gameId: m.gameId, gameVersion: m.gameVersion }
      S.sessionId = 'mock-' + Date.now().toString(36)
      S.nonce = [...crypto.getRandomValues(new Uint8Array(12))].map((b) => b.toString(16).padStart(2, '0')).join('')
      counts.messages++; window.__messages.push(m)
      line(`ready  ${m.gameId}@${m.gameVersion} ${JSON.stringify(m.payload)}`)
      send(HOST.initialize, { hostOrigin: location.origin }); refresh(); return
    }
    if (m.sessionId !== S.sessionId || m.nonce !== S.nonce) return reject(m, 'session/nonce binding')
    if (m.attemptId !== undefined && m.attemptId !== S.attempt) return reject(m, `attemptId ${m.attemptId} is not the active attempt`)
    counts.messages++; window.__messages.push(m)
    const rec = S.attempt && window.__attempts[S.attempt]
    switch (m.messageType) {
      case GAME.attemptStartRequested: {
        line(`game → start requested ${m.payload.levelId}`)
        if (S.attempt) { send(HOST.attemptStartRejected, { levelId: m.payload.levelId, reasonCode: 'attempt_active' }); break }
        if (document.getElementById('reject').checked) {
          document.getElementById('reject').checked = false
          send(HOST.attemptStartRejected, { levelId: m.payload.levelId, reasonCode: 'mock_rejected' }); break
        }
        const levelId = m.payload.levelId
        // The platform's side of the bet (document §2): debit, record the bar's p at the time of the bet, then authorize. Only the authorization reaches the game.
        const authorize = (bet) => {
          const attemptId = 'att-' + crypto.randomUUID()
          const bad = document.getElementById('badrules').checked
          document.getElementById('badrules').checked = false
          const authorization = { attemptId, levelId, levelVersion: S.game.gameVersion, seed: rand(), rulesVersion: bad ? 'bogus-rules' : '01HZZZZZZZZZZZZZZZZZZZZZZZ' }
          S.attempt = attemptId; S.outcome = false
          const { pAtBet } = placeBet(state, PARAMS, attemptId, levelId, bet); render()
          line(`platform: aposta ${brl(bet)} debitada no nível ${levelId} (barra ${num(pAtBet)}%) — fictício`, 'money')
          window.__attempts[attemptId] = { authorization, actions: [], checkpoints: [], outcome: null }
          S.lastStarted = send(HOST.attemptStarted, authorization, { attemptId })
          refresh()
        }
        if (autobet()) { authorize(Math.min(autoBetAmount(), Math.max(state.wallet, 0))); break }
        // the game only asked: the player decides in the platform's modal, and the authorization goes after the confirmation
        S.pending = { levelId, authorize }
        const lvl = levelOf(state, levelId, PARAMS), ref = PARAMS.finite.levels[levelId]?.medianRef
        $('betInfo').textContent = `Saldo: ${brl(state.wallet)} (fictício) · nível ${levelId} · barra ${num(lvl.p)}%`
        $('betBonus').textContent = ref ? `Bônus na vitória: ${pct(finiteBonusPct(ref, levelId, PARAMS, lvl))} da aposta numa partida mediana (${ref} pts), mais pela pontuação; pago no fim do evento, sujeito ao pote.` : ''
        $('betOpts').replaceChildren(...PARAMS.wallet.bets.map((b) => Object.assign(document.createElement('button'), { textContent: brl(b), disabled: b > state.wallet, onclick: () => { $('betModal').classList.remove('show'); const p = S.pending; S.pending = null; p?.authorize(b) } })))
        $('betModal').classList.add('show')
        break
      }
      case GAME.action:
        rec?.actions.push(m.payload)
        line(`${String(m.payload.elapsedMs ?? '').padStart(7)}ms  #${m.payload.sequence} ${m.payload.type}`); break
      case GAME.checkpoint: rec?.checkpoints.push(m.payload); line(`checkpoint score=${m.payload.score}`); break
      case GAME.attemptSuspended: line(`suspended (${m.payload.reason})`); break
      case GAME.attemptCompleted:
      case GAME.attemptFailed:
        if (rec) rec.outcome = { type: m.messageType, ...m.payload }
        S.outcome = true
        line(`${m.messageType} level=${m.payload.levelId} actions=${m.payload.actionSequence}`)
        settle(S.attempt, rec, m.messageType === GAME.attemptCompleted)
        if (document.getElementById('autofinal').checked) setTimeout(finalize, 150)
        break
      case GAME.closeRequested:
        counts.closeRequests++; line('game asked to close')
        if (!autobet()) $(S.attempt && !S.outcome ? 'quitModal' : 'lobby').classList.add('show')
        break
      case GAME.error:
        // Diagnostic only (guide §4): the host decides what to show; the attempt is not settled by it.
        line(`game.error ${m.payload.code}${m.payload.detail ? ': ' + m.payload.detail : ''}`, 'bad'); break
      case GAME.fullscreenRequested: line('game asked for fullscreen (ignored by the mock)'); break
      default: line(`game → ${m.messageType}`)
    }
    refresh()
  })

  // Settlement of a finished attempt by the simulated economy: attempt.completed is the victory of the contract (the game reports, the platform decides).
  function settle(attemptId, rec, completed, abandoned = false) {
    if (!attemptId || !state.openBets[attemptId]) return
    const score = rec?.checkpoints.at(-1)?.score ?? 0
    const s = resolveAttempt(state, PARAMS, attemptId, { won: completed && !abandoned, score })
    render()
    if (s.kind === 'win') {
      $('lastCard').className = 'card win'; $('lastTitle').textContent = `Ganhou: aposta de volta + bônus ${brl(s.bonusRequested)}`
      $('lastInfo').textContent = `placar ${score} · bônus ${pct(s.bonusPct)} da aposta de ${brl(s.bet)} · ${s.bonusPaidNow ? `pago ${brl(s.bonusPaidNow)}` : 'pago no fim do evento (sujeito ao pote)'} · barra ${num(s.pBefore)}% → ${num(s.pAfter)}% · ranking +${Math.round(s.rankingPoints)} pts`
      ribbon(`Vitória! ${brl(s.bet)} de volta + bônus de ${brl(s.bonusRequested)} no fim do evento`, 'win')
      line(`platform: vitória, bônus pedido ${brl(s.bonusRequested)} (${pct(s.bonusPct)}), barra ${num(s.pBefore)} → ${num(s.pAfter)}`, 'money')
    } else {
      $('lastCard').className = 'card lose'; $('lastTitle').textContent = `${abandoned ? 'Desistiu' : 'Perdeu'}: ${brl(s.split.piggyShown)} no cofrinho`
      $('lastInfo').textContent = `placar ${score} · aposta ${brl(s.bet)}: ${brl(s.split.piggyFromBet)} + ${brl(s.split.piggyTopUp)} da casa no cofrinho, ${brl(s.split.general)} no pote geral (${brl(s.split.progression)} progressão) · barra ${num(s.pBefore)}% → ${num(s.pAfter)}%`
      ribbon(`Não foi desta vez: ${brl(s.split.piggyShown)} foram para o seu cofrinho`, 'lose')
      line(`platform: derrota, cofrinho +${brl(s.split.piggyShown)}, pote +${brl(s.split.general)}, barra ${num(s.pBefore)} → ${num(s.pAfter)}`, 'money')
    }
  }
  $('betCancel').onclick = () => {
    $('betModal').classList.remove('show')
    const p = S.pending; S.pending = null
    if (p) send(HOST.attemptStartRejected, { levelId: p.levelId, reasonCode: 'player_declined' })
  }
  $('quitStay').onclick = () => $('quitModal').classList.remove('show')
  $('quitGo').onclick = () => {
    $('quitModal').classList.remove('show')
    settle(S.attempt, S.attempt && window.__attempts[S.attempt], false, true) // abandonment is the platform's: a lost bet (QPP §2)
    $('lobby').classList.add('show')
  }
  $('lobbyOpen').onclick = () => { $('lobby').classList.remove('show'); S.attempt = null; S.outcome = false; frame.src = frame.src; refresh() }
  document.getElementById('finalize').onclick = finalize
  // Same authorization again with a new messageId: the game must not count it twice.
  document.getElementById('dupauth').onclick = () => S.lastStarted && send(HOST.attemptStarted, S.lastStarted.payload, { attemptId: S.lastStarted.attemptId })
  // Finalization of an attempt that is already over: the game must ignore it.
  document.getElementById('stale').onclick = () => S.lastAttemptId && send(HOST.attemptFinalized, {}, { attemptId: S.lastAttemptId })
  document.getElementById('resumed').onclick = () => S.attempt && send(HOST.attemptResumed, {}, { attemptId: S.attempt })
  document.getElementById('clear').onclick = () => (log.textContent = '')
  document.getElementById('export').onclick = () => {
    const a = document.createElement('a')
    a.href = URL.createObjectURL(new Blob([JSON.stringify(Object.values(window.__attempts), null, 2)], { type: 'application/json' }))
    a.download = 'hitz-attempts.json'; a.click()
  }
  refresh()
